import { useEffect, useMemo } from 'react';

import { useChallengeCelebrationModalQuery } from '../../graphql/ChallengesCelebrationModal.query.generated';

export function useChallengeCompletionModal(orderId: string) {
  const [
    { data: celebrationModal, fetching: fetchingCelebrationModal },
    fetchChallengeCelebrationModal,
    ,
  ] = useChallengeCelebrationModalQuery({
    pause: true,
    requestPolicy: 'cache-and-network',
  });

  // ─── Derived Data ────────────────────────────────────────────────────

  const celebration = celebrationModal?.challengeCelebrationV2;
  const fetchingCelebration = fetchingCelebrationModal;

  // ─── Effects ─────────────────────────────────────────────────────────
  // the useEffect is used to prevent duplicated network requests.

  useEffect(() => {
    fetchChallengeCelebrationModal();
  }, [orderId, fetchChallengeCelebrationModal]);

  return useMemo(() => ({ celebration, fetchingCelebration }), [celebration, fetchingCelebration]);
}
